<template>
    <div class="booking-route">
        <h4>Route</h4>
        <div class="form-group">
            <label :for="`start_location-${tripId}`">Start Location</label>
            <select v-model="start" class="form-control" :id="`start_location-${tripId}`">
                <option 
                    v-for="locationOption, index in locationOptions" 
                    :key="index" 
                    :value="locationOption"
                    :disabled="locationOption === end"
                >
                    {{ locationOption }}
                </option>
            </select>
            <div v-if="errors?.start_location?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.start_location" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label :for="`end_location-${tripId}`">End Location</label>
            <select v-model="end" class="form-control" :id="`end_location-${tripId}`">
                <option 
                    v-for="locationOption, index in locationOptions"
                    :key="index" 
                    :value="locationOption"
                    :disabled="locationOption === start"
                >
                    {{ locationOption }}
                </option>
            </select>
            <div v-if="errors?.end_location?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.end_location" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        startLocation: String,
        endLocation: String,
        tripId: Number,
        bookingService: Object,
        errors: Object
    },
    data() {
        return {
            locationOptions: []
        }
    },
    computed: {
        start: {
            get() { 
                return this.startLocation;
            },
            set(value) {
                this.$emit('update:startLocation', value);
            }
        },
        end: {
            get() { 
                return this.endLocation;
            },
            set(value) {
                this.$emit('update:endLocation', value);
            }
        }
    },
    created() {
        this.bookingService.getStops().then(data => this.locationOptions = data);
    }
}
</script>

<style lang="scss">
.booking-route {
    h4 {
        font-size: 1.1rem;
    }

    margin-bottom: 40px;
}
</style>